import { useQuestionizerStore } from "../types/state";

export default function StepNavigation (){
  const stepsCount = useQuestionizerStore((state) => state.stepsCount());
  const step = useQuestionizerStore((state) => state.step);

  let steps = [];
  for (let i = 0; i < stepsCount; i++){
    steps.push(<Step key={i} index={i} active={i === step}/>);
  }
  return <div role="menubar" className='step_navigation'>
	<StepReset/>
    {steps}
  <ContrastMode/>
  </div>
}

function StepReset(){
  const resetState = useQuestionizerStore((state) => state.resetState);
  const line_active_style = " step_navigation__line step_navigation__line--active ";
  const point_reset_style = " step__point step_navigation__step_reset ";

  return <div role="menuitem" tabIndex={0} className={'step_navigation__step'} 
      onClick={()=>{
			  resetState();
			}} 
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        resetState();
      }}
		>
      <div className={line_active_style}></div>
      <div className={point_reset_style}>
		<abbr title="Neu Abfrage starten"><div className={'icon-inline--right icon-reset--white'}></div></abbr>
	  </div>
    </div>
}

function ContrastMode(){
  const toggle_contrast_mode = useQuestionizerStore((state) => state.toggle_contrast_mode);

  return <div role="menuitem" style={{ display: 'none' }} tabIndex={0} className={'step_navigation__step'} 
      onClick={()=>{
        toggle_contrast_mode();
			}}
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        toggle_contrast_mode();
      }}>
      <abbr className="step__point" title="Kontrastmodus umschalten"><div className={'icon icon-access'}></div></abbr>
		</div>
}


function Step(props: {index: number, active: boolean}){
  const setStep = useQuestionizerStore((state) => state.setStep);
  const step_progression = useQuestionizerStore((state) => state.step_progression);

  const point_disabled_style = " step__point step__point--disabled pointer-events-none ";
  const point_active_style = " step__point step__point--active ";
  const point_inactive_style = " step__point ";

  const line_disabled_style = " step_navigation__line step_navigation__line--disabled pointer-events-none ";
  const line_active_style = " step_navigation__line step_navigation__line--active ";
  const line_inactive_style = " step_navigation__line ";

  const reachable = props.index <= step_progression;
  return <div role="menuitem" tabIndex={0} className={'step_navigation__step'} 
      onClick={()=>{
        if(reachable){setStep(props.index, false)}
      }}
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        if(reachable){setStep(props.index, false)}
      }}>
      <div className={!reachable ? line_disabled_style : (props.active ? line_active_style : line_inactive_style)}></div>
      <div className={!reachable ? point_disabled_style : (props.active ? point_active_style : point_inactive_style)}>{props.index + 1}</div>
    </div>
}